import { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Container } from '@mui/material';

import SentryErrorBoundary from 'Lib/components/errors/SentryErrorBoundary';
import Navigation from 'Lib/components/layout/Navigation';
import NotFound from 'Lib/components/layout/NotFound';
import PortalTypes from 'Lib/constants/app/portalTypes';
import ChatObjectTypes from 'Lib/constants/communications/chatObjectTypes';

import PortalSelected from './PortalSelected';

import 'react-toastify/dist/ReactToastify.css';
import '~/scss/app.scss';

import { getMessageStats } from '~/api/chat';
import NAVIGATION_ITEMS from '~/constants/layout.js/NavigationItems';
import Authenticated from '~/containers/Authenticated';
import AppLayout from '~/containers/layouts/App';
import routes from '~/routes';
import * as app from '~/services/app';
import * as session from '~/services/session';
import { showMenu } from '~/services/ui/actions';

const mapStateToProps = state => ({
	app: state.app,
	portalAccounts: state.app.portalAccounts,
	ui: state.ui
});

const mapDispatchToProps = {
	showMenu
};

class App extends Component {
	state = {
		items: [],
		intervalID: null,
		unreadMessageCount: 0
	};

	componentWillUnmount() {
		clearInterval(this.state.intervalID);
	}

	getStats = () => {
		getMessageStats({ chatObjectTypeID: ChatObjectTypes.Applicant }).then(response => {
			if (response.data.unreadCount > 0) {
				this.setState({
					unreadMessageCount: response.data.unreadCount
				});
			}
		});
	};

	onChangePortal = portal => {
		app.setPortal(portal);
	};

	render() {
		const { unreadMessageCount } = this.state;
		const { app, ui, portalAccounts } = this.props;

		return (
			<>
				<Router basename="/portals/applicant">
					<Container
						disableGutters
						maxWidth={false}
						sx={theme => ({
							bgcolor: 'common.background',
							[theme.breakpoints.up('md')]: {
								height: '100vh',
								overflow: 'hidden'
							}
						})}>
						<Authenticated>
							<PortalSelected>
								<Navigation
									matchExact
									app={app}
									items={NAVIGATION_ITEMS}
									session={session}
									open={ui.menuVisible}
									portalAccounts={portalAccounts}
									portalTypeID={PortalTypes.Applicant}
									unreadMessageCount={unreadMessageCount}
									showMenu={this.props.showMenu}
									toggleDrawer={() => this.props.showMenu(!ui.menuVisible)}
									onChangePortal={this.onChangePortal}
									onChangeLease={this.onChangeLease}
								/>
								<Switch>
									{routes.map((route, index) => (
										<Route
											key={index}
											exact={true}
											path={route.path}
											render={props => {
												let Layout = AppLayout;

												if (route.layout) {
													Layout = route.layout;
												}

												return (
													<Layout>
														<SentryErrorBoundary>
															<route.component route={props} routes={route.routes} />
														</SentryErrorBoundary>
													</Layout>
												);
											}}
										/>
									))}
									<Route route="*" component={NotFound} />
								</Switch>
							</PortalSelected>
						</Authenticated>
					</Container>
				</Router>
				<ToastContainer
					position="bottom-right"
					theme="colored"
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnVisibilityChange
					draggable
					pauseOnHover
				/>
			</>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
